import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "module_more_results" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "module_more_results-link" }, "Cargar más resultados", -1)


export default /*#__PURE__*/_defineComponent({
  props: {
  expandedState: Boolean,
  module: String
},
  setup(__props) {





function openModuleInNovatrans(module: string | undefined) {
  var data = { formulario: module, elemento: module }
  var dataJson = JSON.stringify(data)
  window.chrome?.webview?.postMessage(dataJson)
  console.log(`open in Novatrans ${module}`)
  return false
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.expandedState)
      ? _renderSlot(_ctx.$slots, "default", { key: 0 }, () => [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (openModuleInNovatrans(__props.module))),
            class: "btn btn-primary"
          }, "Abrir módulo")
        ])
      : _renderSlot(_ctx.$slots, "default", { key: 1 }, () => [
          _hoisted_2
        ])
  ]))
}
}

})